import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeSourceNumber = async ({ docId, sourceNumber }) => {
  let url = `/Docs/source_number/${docId}`;

  if (sourceNumber) {
    url += `?sourceNumber=${sourceNumber}`;
  }

  return await request.put(
    url,
    null,
    'При изменении даты документа произошла ошибка',
    'Error'
  );
};

const useChangeSourceNumber = () => {
  const mutation = useMutation(changeSourceNumber, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingSourceNumber: mutation.isLoading,
    changeSourceNumber: mutation.mutateAsync,
  };
};

export default useChangeSourceNumber;
